const makeConstant = constant => `billing/${constant}`

export const SET_PLAN = makeConstant('SET_PLAN')
export const SET_COUPON = makeConstant('SET_COUPON')

export const FETCH_DEAL = makeConstant('FETCH_DEAL')
export const FETCH_DEAL_SUCCESS = makeConstant('FETCH_DEAL_SUCCESS')
export const FETCH_DEAL_PENDING = makeConstant('FETCH_DEAL_PENDING')
export const FETCH_DEAL_FAILED = makeConstant('FETCH_DEAL_FAILED')

export const ACTIVATE_DEAL = makeConstant('ACTIVATE_DEAL')
export const ACTIVATE_DEAL_SUCCESS = makeConstant('ACTIVATE_DEAL_SUCCESS')
export const ACTIVATE_DEAL_PENDING = makeConstant('ACTIVATE_DEAL_PENDING')
export const ACTIVATE_DEAL_FAILED = makeConstant('ACTIVATE_DEAL_FAILED')



// WEBPACK FOOTER //
// ./src/modules/billing/constants.js